module.exports = __webpack_public_path__ + "portal-static/img/assessment.f93502c7.png";